import { render, staticRenderFns } from "./arquivo.vue?vue&type=template&id=7c74a6ea&"
import script from "./arquivo.vue?vue&type=script&lang=js&"
export * from "./arquivo.vue?vue&type=script&lang=js&"
import style0 from "./arquivo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports